// extracted by mini-css-extract-plugin
module.exports = {"actions":"CookiesActions_actions__bfxHN","actions__button-motion":"CookiesActions_actions__button-motion__p57hW","actions__button":"CookiesActions_actions__button__gJqB1"};